module.exports = __webpack_public_path__ + "static/media/Kuva_6_5.0ae81dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_6_5.png
// module id = 1402
// module chunks = 0